export function CountdownRing({ daysLeft, totalDays = 31, size = 88, color = 'var(--primary-color)', testId }) {
    const stroke = 7;
    const r = (size - stroke) / 2;
    const circ = 2 * Math.PI * r;
    const frac = Math.max(0, Math.min(1, daysLeft / totalDays));
    return (
        <div className="relative inline-flex items-center justify-center shrink-0" style={{ width: size, height: size }} data-testid={testId || 'countdown-ring'}>
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth={stroke} />
                <circle
                    cx={size / 2} cy={size / 2} r={r} fill="none"
                    stroke={color} strokeWidth={stroke} strokeLinecap="round"
                    strokeDasharray={circ}
                    strokeDashoffset={circ * (1 - frac)}
                    style={{ transition: 'stroke-dashoffset 1s ease' }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="font-black font-mono leading-none" style={{ color, fontSize: size / 3.4 }}>{daysLeft}</span>
                <span className="uppercase tracking-wider" style={{ color: 'var(--text-muted)', fontSize: size / 9 }}>days</span>
            </div>
        </div>
    );
}
